// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"fileBlock_linkWrapper__WNeL1","fileBlock":"fileBlock_fileBlock__Q6vay"};